import PresetInterface from "../../../interfaces/PresetInterface";

export default function (preset: PresetInterface, pretty = true): number|string {

    let val: number = 0

    preset.items.forEach((item) => {
        let countField = item.custom_fields.filter((f) => f.id === 1)
        let saleField = item.custom_fields.filter((f) => f.id === preset.checkboxes.sale)

        if (countField.length > 0 && saleField.length > 0) {
            let to_add = parseInt(countField[0].values[0].value) * parseFloat(saleField[0].values[0].value)
            if (!isNaN(to_add))
            val += to_add
        }
    })

    if (pretty) return val.toLocaleString('ru-RU')
    return parseFloat(val.toFixed(2))
}